
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/terms_of_service_modal';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('terms_of_service_modal');
  